import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSocket } from '../context/SocketContext';

const StudentJoin = () => {
  const [name, setName] = useState('');
  const [roomCode, setRoomCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { socket } = useSocket();
  const navigate = useNavigate();

  const handleJoin = (e) => {
    e.preventDefault();
    if (!socket) {
      setError('Připojení k serveru není aktivní');
      return;
    }

    setError('');
    setLoading(true);

    // Použít sessionId pouze pokud se připojujeme do stejné místnosti
    const savedRoomCode = localStorage.getItem('roomCode');
    const sessionId = (savedRoomCode === roomCode.toUpperCase())
      ? localStorage.getItem('sessionId')
      : null;

    socket.emit(
      'student:join-game',
      { roomCode: roomCode.toUpperCase(), name, sessionId },
      (response) => {
        setLoading(false);
        if (response.success) {
          // Uložit sessionId pro reconnect
          localStorage.setItem('sessionId', response.sessionId);
          localStorage.setItem('roomCode', roomCode.toUpperCase());
          localStorage.setItem('playerName', name);
          
          navigate(`/game/${roomCode.toUpperCase()}`);
        } else {
          setError(response.message);
        }
      }
    );
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-2">CodeSwap</h1>
          <p className="text-gray-600">Připojit se ke hře</p>
        </div>

        <form onSubmit={handleJoin} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Tvoje jméno
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              required
              placeholder="Petr Novák"
              maxLength={30}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Kód místnosti
            </label>
            <input
              type="text"
              value={roomCode}
              onChange={(e) => setRoomCode(e.target.value.toUpperCase())}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent text-center text-2xl font-bold tracking-widest"
              required
              placeholder="ABC123"
              maxLength={6}
            />
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg text-sm">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !socket}
            className="w-full bg-primary-600 text-white py-3 rounded-lg font-semibold hover:bg-primary-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            {loading ? 'Připojování...' : 'Připojit se'}
          </button>
        </form>

        <div className="mt-6 text-center">
          <button
            onClick={() => navigate('/')}
            className="text-primary-600 hover:text-primary-700 font-medium"
          >
            ← Zpět na přihlášení učitele
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudentJoin;
